import { Injectable } from '@angular/core'

export const US_STATES: any[] = [
  {
    label: 'Alaska',
    value: 'AK'
  },
  {
    label: 'Alabama',
    value: 'AL'
  },
  {
    label: 'Arkansas',
    value: 'AR'
  },
  {
    label: 'American Samoa',
    value: 'AS'
  },
  {
    label: 'Arizona',
    value: 'AZ'
  },
  {
    label: 'California',
    value: 'CA'
  },
  {
    label: 'Colorado',
    value: 'CO'
  },
  {
    label: 'Connecticut',
    value: 'CT'
  },
  {
    label: 'District of Columbia',
    value: 'DC'
  },
  {
    label: 'Delaware',
    value: 'DE'
  },
  {
    label: 'Florida',
    value: 'FL'
  },
  {
    label: 'Georgia',
    value: 'GA'
  },
  {
    label: 'Guam',
    value: 'GU'
  },
  {
    label: 'Hawaii',
    value: 'HI'
  },
  {
    label: 'Iowa',
    value: 'IA'
  },
  {
    label: 'Idaho',
    value: 'ID'
  },
  {
    label: 'Illinois',
    value: 'IL'
  },
  {
    label: 'Indiana',
    value: 'IN'
  },
  {
    label: 'Kansas',
    value: 'KS'
  },
  {
    label: 'Kentucky',
    value: 'KY'
  },
  {
    label: 'Louisiana',
    value: 'LA'
  },
  {
    label: 'Massachusetts',
    value: 'MA'
  },
  {
    label: 'Maryland',
    value: 'MD'
  },
  {
    label: 'Maine',
    value: 'ME'
  },
  {
    label: 'Michigan',
    value: 'MI'
  },
  {
    label: 'Minnesota',
    value: 'MN'
  },
  {
    label: 'Missouri',
    value: 'MO'
  },
  {
    label: 'Northern Mariana Islands',
    value: 'MP'
  },
  {
    label: 'Mississippi',
    value: 'MS'
  },
  {
    label: 'Montana',
    value: 'MT'
  },
  {
    label: 'North Carolina',
    value: 'NC'
  },
  {
    label: 'North Dakota',
    value: 'ND'
  },
  {
    label: 'Nebraska',
    value: 'NE'
  },
  {
    label: 'New Hampshire',
    value: 'NH'
  },
  {
    label: 'New Jersey',
    value: 'NJ'
  },
  {
    label: 'New Mexico',
    value: 'NM'
  },
  {
    label: 'Nevada',
    value: 'NV'
  },
  {
    label: 'New York',
    value: 'NY'
  },
  {
    label: 'Ohio',
    value: 'OH'
  },
  {
    label: 'Oklahoma',
    value: 'OK'
  },
  {
    label: 'Oregon',
    value: 'OR'
  },
  {
    label: 'Pennsylvania',
    value: 'PA'
  },
  {
    label: 'Puerto Rico',
    value: 'PR'
  },
  {
    label: 'Rhode Island',
    value: 'RI'
  },
  {
    label: 'South Carolina',
    value: 'SC'
  },
  {
    label: 'South Dakota',
    value: 'SD'
  },
  {
    label: 'Tennessee',
    value: 'TN'
  },
  {
    label: 'Texas',
    value: 'TX'
  },
  {
    label: 'United States Minor Outlying Islands',
    value: 'UM'
  },
  {
    label: 'Utah',
    value: 'UT'
  },
  {
    label: 'Virginia',
    value: 'VA'
  },
  {
    label: 'Virgin Islands',
    value: 'VI'
  },
  {
    label: 'Vermont',
    value: 'VT'
  },
  {
    label: 'Washington',
    value: 'WA'
  },
  {
    label: 'Wisconsin',
    value: 'WI'
  },
  {
    label: 'West Virginia',
    value: 'WV'
  },
  {
    label: 'Wyoming',
    value: 'WY'
  },
  {
    label: 'Armed Forces Americas (except Canada)',
    value: 'AA'
  },
  {
    label: 'Armed Forces Africa, Canada, Europe, Middle East',
    value: 'AE'
  },
  {
    label: 'Armed Forces Pacific',
    value: 'AP'
  }
]

export const CANADIAN_STATES: any[] = [
  {
    label: 'Alberta',
    value: 'AB'
  },
  {
    label: 'British Columbia',
    value: 'BC'
  },
  {
    label: 'Manitoba',
    value: 'MB'
  },
  {
    label: 'New Brunswick',
    value: 'NB'
  },
  {
    label: 'Newfoundland and Labrador',
    value: 'NL'
  },
  {
    label: 'Nova Scotia',
    value: 'NS'
  },
  {
    label: 'Northwest Territories',
    value: 'NT'
  },
  {
    label: 'Nunavut',
    value: 'NU'
  },
  {
    label: 'Ontario',
    value: 'ON'
  },
  {
    label: 'Prince Edward Island',
    value: 'PE'
  },
  {
    label: 'Quebec',
    value: 'QC'
  },
  {
    label: 'Saskatchewan',
    value: 'SK'
  },
  {
    label: 'Yukon Territory',
    value: 'YT'
  }
]

export enum CountryCode {
  CA = 'CA',
  US = 'US'
}

export const COUNTRIES: CountryOption[] = [
  { label: 'United States', value: CountryCode.US, alias: ['USA'] },
  { label: 'Canada', value: CountryCode.CA, alias: ['CAN'] }
]

export const COUNTRY_STATES: any = {
  US: US_STATES,
  CA: CANADIAN_STATES
}

export interface CountryOption {
  label: string,
  value: string,
  alias?: string[]
}

@Injectable({
  providedIn: 'root'
})
export class GeographicService {

  public getCountryOptions(selectedCountry?: string): CountryOption[] {
    const countries = Object.assign([], COUNTRIES)
    if (selectedCountry && !['US', 'CA'].includes(selectedCountry)) {
      countries.push({ label: selectedCountry, value: selectedCountry })
    }
    return countries
  }

  public getCountryByValue(country: string): CountryOption {
    return this.getCountryOptions(country).find((option: CountryOption) => {
      // search for a country with a value matching the given `country`;
      // also check aliases, so both US and USA return United States
      return (option.value === country) || (option.alias.find((aliasValue) => aliasValue === country))
    })
  }

  public isCanadian(country: string): boolean {
    const countryOption = this.getCountryByValue(country)
    return (countryOption && countryOption.value === CountryCode.CA)
  }

  public isAmerican(country: string): boolean {
    const countryOption = this.getCountryByValue(country)
    return (countryOption && countryOption.value === CountryCode.US)
  }

  public getStateOptions(selectedCountry: string, selectedState?: string): any[] {
    const countryStates = Object.assign([], COUNTRY_STATES)
    if (!Object.keys(countryStates).includes(selectedCountry)) {
      countryStates[selectedCountry] = []
    }
    const states = [...countryStates[selectedCountry]]
    if (selectedState && !states.map(state => state.value).includes(selectedState)) {
      states.push({ value: selectedState, label: selectedState })
    }
    return [{ label: 'Select your State / Province', value: null }].concat(states)
  }
}
